import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/admin/login", { email, password });
      toast.success("Welcome, admin");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16 bg-ink-900 text-cream-100 -mx-6">
      <form onSubmit={submit} className="w-full max-w-md bg-ink-900 border border-gold-500/30 p-10">
        <img
          src="/logo-black-1.png"
          alt="IMMUSKI"
          style={{ height: 72, width: "auto" }}
          className="mb-6 mx-auto"
        />
        <div className="flex items-center gap-2 eyebrow text-gold-400">
          <Lock size={12} /> Admin console
        </div>
        <h1 className="mt-3 font-display text-4xl">IMMUSKI Admin</h1>
        <p className="mt-2 text-sm text-cream-100/60">Manage orders, coupons, products and campaigns.</p>

        <div className="mt-8 space-y-4">
          <div>
            <Label className="text-cream-100/80">Email</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 rounded-none bg-ink-900 border-gold-500/30 text-cream-100" data-testid="admin-email" />
          </div>
          <div>
            <Label className="text-cream-100/80">Password</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 rounded-none bg-ink-900 border-gold-500/30 text-cream-100" data-testid="admin-password" />
          </div>
        </div>
        <button type="submit" disabled={loading} className="mt-8 w-full bg-gold-500 text-ink-900 py-3 text-xs uppercase tracking-[0.28em] hover:bg-gold-400 disabled:opacity-50" data-testid="admin-login-submit">
          {loading ? "Signing in…" : "Sign in"}
        </button>
        <div className="mt-4 text-center">
          <a href="/admin/reset-password" className="text-[11px] uppercase tracking-widest text-cream-100/60 hover:text-gold-400" data-testid="admin-forgot-password">
            Forgot password?
          </a>
        </div>
      </form>
    </div>
  );
}
